import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, NavLink, Link } from "react-router-dom";
import {
  FaRecycle,
  FaRupeeSign,
  FaShoppingCart,
  FaAngleDown,
  FaUser,
} from "react-icons/fa";
import {
  RiHomeGearFill,
  RiMentalHealthFill,
  RiBarChart2Fill,
} from "react-icons/ri";
import { MdOutlineGroups } from "react-icons/md";
import Cookies from "js-cookie";
import { CiBank } from "react-icons/ci";
import { CgProfile } from "react-icons/cg";
import { GiWallet, GiNotebook } from "react-icons/gi";
import { IoSettings } from "react-icons/io5";
import { MdOutlineLogout } from "react-icons/md";
import { Getcompanybanks } from "../store/slices/bankbook";
import logo from "../img/logos/kisaankhatalogo.png";

const Navbarside = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [show, setShow] = useState("");
  const [bankData, setBankData] = useState();

  const user = JSON.parse(localStorage.getItem("user"));
  const role = user?.data?.role;
  const permissions = user?.data?.permissions?.split(",") || [];
  const isAdmin = role === "Admin";
  // console.log(isAdmin)

  const signOut = () => {
    // Clear localStorage and cookies
    clearCacheData();
    localStorage.clear();
    Cookies.remove("user");
    navigate("/home");
  };

  const clearCacheData = () => {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
  };

  React.useEffect(() => {
    dispatch(Getcompanybanks())
      .unwrap()
      .then((data) => {
        setBankData(data.data);
      })
      .catch(({ message }) => {
        console.log(message);
      });
  }, [dispatch]);

  return (
    <>
      {/* Sidebar */}
      <div className="col-md-2 sidebar">
        <div className="row">
          <div className="col-12 text-center logo">
            <img src={logo} alt="logo" className="img-responsive" />
          </div>
        </div>
        <div className="row navbar">
          <nav className="sidebar" id="side">
            <ul className="nav-lists pt-1">
              <li className="nav_items top_item">
                <NavLink to="/" className="menu-title" activeClassName="active">
                  <RiHomeGearFill className="nav_icons" />
                  Dashboard
                </NavLink>
              </li>
              <li className="nav_items">
                <NavLink to="/fop-lifecycle" className="menu-title">
                  <FaRecycle className="nav_icons" />
                  FPO Lifecycle
                </NavLink>
              </li>
              {(isAdmin ||
                [
                  "Invoices",
                  "Quotation",
                  "Credit Note",
                  "Delivery",
                  "Payment In",
                ]?.some((permission) => permissions?.includes(permission))) && (
                <li className="nav_items">
                  <p
                    className="menu-title"
                    onClick={() => {
                      setShow(show === "Sale" ? "" : "Sale");
                    }}
                  >
                    <FaRupeeSign className="nav_icons" />
                    Sale
                    <FaAngleDown
                      style={{ float: "right", fontSize: "0.9rem" }}
                    />
                  </p>
                  {show === "Sale" && (
                    <ul className="submenu">
                      {(isAdmin || permissions.includes("Invoices")) && (
                        <li className="submenu-item">
                          <NavLink to="/invoicelist" className="menu-title">
                            Invoices
                          </NavLink>
                        </li>
                      )}
                      {(isAdmin || permissions.includes("Quotation")) && (
                        <li className="submenu-item">
                          <NavLink to="/quotation/list" className="menu-title">
                            Quotation
                          </NavLink>
                        </li>
                      )}
                      {(isAdmin || permissions.includes("Credit Note")) && (
                        <li className="submenu-item">
                          <NavLink to="/creditnotelist" className="menu-title">
                            Credit Note / Return
                          </NavLink>
                        </li>
                      )}
                      {(isAdmin || permissions.includes("Delivery")) && (
                        <li className="submenu-item">
                          <NavLink to="/Sale/Submenu2" className="menu-title">
                            Delivery
                          </NavLink>
                        </li>
                      )}
                      {(isAdmin || permissions.includes("Payment In")) && (
                        <li className="submenu-item">
                          <NavLink
                            to="/invoicepaymentlist"
                            className="menu-title"
                          >
                            Payment In
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  )}
                </li>
              )}

              {(isAdmin ||
                [
                  "Purchase Voucher",
                  "Purchase Order",
                  "Payment Out",
                  "Debit Note",
                ].some((permission) => permissions.includes(permission))) && (
                <li className="nav_items">
                  <p
                    className="menu-title"
                    onClick={() => {
                      setShow(show === "Purchase" ? "" : "Purchase");
                    }}
                  >
                    <FaShoppingCart className="nav_icons" />
                    Purchase
                    <FaAngleDown
                      style={{ float: "right", fontSize: "0.9rem" }}
                    />
                  </p>
                  {show === "Purchase" && (
                    <ul className="submenu">
                      {(isAdmin ||
                        permissions.includes("Purchase Voucher")) && (
                        <li className="submenu-item">
                          <NavLink
                            to="/purchase/purchasevoucherlist"
                            className="menu-title"
                          >
                            Purchase Voucher
                          </NavLink>
                        </li>
                      )}
                      {(isAdmin || permissions.includes("Purchase Order")) && (
                        <li className="submenu-item">
                          <NavLink
                            to="/purchase/purchaseorderlist"
                            className="menu-title"
                          >
                            Purchase Order (PO)
                          </NavLink>
                        </li>
                      )}
                      {(isAdmin || permissions.includes("Payment Out")) && (
                        <li className="submenu-item">
                          <NavLink
                            to="/purchase/paymentoutlist"
                            className="menu-title"
                          >
                            Payment Out
                          </NavLink>
                        </li>
                      )}
                      {(isAdmin || permissions.includes("Debit Note")) && (
                        <li className="submenu-item">
                          <NavLink
                            to="/purchase/debitnotelist"
                            className="menu-title"
                          >
                            Debit Note / Return
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  )}
                </li>
              )}
              {(isAdmin || permissions.includes("Ledger")) && (
                <li className="nav_items">
                  <NavLink to="/ledgerlist" className="menu-title">
                    <CgProfile className="nav_icons" />
                    Ledger
                  </NavLink>
                </li>
              )}
              {(isAdmin || permissions.includes("Ledger")) && (
                <li className="nav_items">
                  <NavLink to="/ledgergroup" className="menu-title">
                    <MdOutlineGroups className="nav_icons" />
                    Group Ledger
                  </NavLink>
                </li>
              )}
              {(isAdmin ||
                ["Items", "Categories", "Closing Stock"].some((permission) =>
                  permissions.includes(permission)
                )) && (
                <li className="nav_items">
                  <p
                    className="menu-title"
                    onClick={() => {
                      setShow(show === "Items" ? "" : "Items");
                    }}
                  >
                    <FaShoppingCart className="nav_icons" />
                    Items
                    <FaAngleDown
                      style={{ float: "right", fontSize: "0.9rem" }}
                    />
                  </p>
                  {show === "Items" && (
                    <ul className="submenu">
                      {(isAdmin || permissions.includes("Items")) && (
                        <li className="submenu-item">
                          <NavLink to="/item" className="menu-title">
                            Item List
                          </NavLink>
                        </li>
                      )}
                      {(isAdmin || permissions.includes("Categories")) && (
                        <li className="submenu-item">
                          <NavLink to="/categories" className="menu-title">
                            Categories
                          </NavLink>
                        </li>
                      )}
                      {(isAdmin || permissions.includes("Closing Stock")) && (
                        <li className="submenu-item">
                          <NavLink
                            to="/closingstocklist"
                            className="menu-title"
                          >
                            Closing Stock
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  )}
                </li>
              )}
              {(isAdmin || permissions.includes("PayRecCont")) && (
                <li className="nav_items">
                  <NavLink
                    to="/payment-receipt-contra/list"
                    className="menu-title"
                  >
                    <GiWallet className="nav_icons" /> Pay/Rec/Cont
                  </NavLink>
                </li>
              )}

              {(isAdmin || permissions.includes("Journal")) && (
                <li className="nav_items">
                  <NavLink to="/journallist" className="menu-title">
                    <RiMentalHealthFill className="nav_icons" /> Journal
                  </NavLink>
                </li>
              )}
              {(isAdmin || permissions.includes("Bank Book")) && (
                <li className="nav_items">
                  <p
                    className="menu-title"
                    onClick={() => {
                      setShow(show === "BankBook" ? "" : "BankBook");
                    }}
                  >
                    <CiBank className="nav_icons" />
                    Bank Book
                    <FaAngleDown
                      style={{ float: "right", fontSize: "0.9rem" }}
                    />
                  </p>
                  {show === "BankBook" && (
                    <ul className="submenu">
                      <li className="submenu-item">
                        <NavLink to="/addbank" className="menu-title">
                          Add Bank
                        </NavLink>
                      </li>
                      {bankData?.map((option, index) => (
                        <li className="submenu-item" key={index}>
                          <NavLink
                            to={{
                              pathname: `/bankbook/${
                                option.id ? option.id : null
                              }`,
                            }}
                            className="menu-title text-uppercase"
                          >
                            {option.ledger}
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              )}

              {(isAdmin || permissions.includes("CashBook")) && (
                <li className="nav_items">
                  <NavLink to="/cashbook" className="menu-title">
                    <GiWallet className="nav_icons" /> Cash Book
                  </NavLink>
                </li>
              )}

              {(isAdmin || permissions.includes('Users')) && (
                <li className="nav_items">
                  <NavLink to="/user-list" className="menu-title">
                    <FaUser className="nav_icons" /> Users
                  </NavLink>
                </li>
              )}
              {(isAdmin ||
                [
                  "Business Reports",
                  "GST Reports",
                  "Stock Reports",
                  "Audit Logs",
                ]?.some((permission) => permissions?.includes(permission))) && (
                <li className="nav_items">
                  <NavLink to="/reportssection" className="menu-title">
                    <RiBarChart2Fill className="nav_icons" /> Reports
                  </NavLink>
                </li>
              )}
              {(isAdmin || permissions.includes("Registers")) && (
                <li className="nav_items">
                  <NavLink to="/registers" className="menu-title">
                    <GiNotebook className="nav_icons" /> Registers
                  </NavLink>
                </li>
              )}

              {(isAdmin || permissions.includes("Settings")) && (
                <li className="nav_items">
                  <NavLink to="/settings" className="menu-title">
                    <IoSettings className="nav_icons" /> Settings
                  </NavLink>
                </li>
              )}

              <li className="nav_items">
                <Link to="/login" onClick={signOut} className="menu-title">
                  <MdOutlineLogout className="nav_icons" />
                  Logout
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Navbarside;
